module.exports = __webpack_public_path__ + "static/media/Yeongwol3.eae6f7b2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Yeongwol3.jpeg
// module id = 585
// module chunks = 0